// extracted by mini-css-extract-plugin
export default {"errorText":"errorText-bc5T7","ellipsis":"ellipsis-jnP2k","show":"show-xP113","hide":"hide-ZOG7B","tooltip":"tooltip-amfUg"};